import { DeclarantLanguage } from '@/common'
import { enGB, de, es } from 'date-fns/locale'
import { Locale } from 'date-fns'
import { useMemo } from 'react'

const localeMap: Record<DeclarantLanguage, Locale> = {
  [DeclarantLanguage.enGB]: enGB,
  [DeclarantLanguage.deDE]: de,
  [DeclarantLanguage.esES]: es
}

const standardFormat = 'yyyy-MM-dd'

export const useDates = (currentLanguage: DeclarantLanguage) => {
  const locale = useMemo(() => localeMap[currentLanguage], [currentLanguage])

  return {
    standardFormat,
    locale
  }
}
